/*
 * src/hooks/useAllCreditTransferTypes.js
 * Description: Query to retrieve transfer types (name / id) where isCredit = true, e.g. "Client Transfer"
 * Copyright (c) 2020 Mark Fehrenbacher
 */
import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';

export const GET_ALL_CREDIT_TRANSFER_TYPES = gql`
  query transfertypes($query: TransfertypeQueryInput!) {
    transfertypes(query: $query) {
      _id
      name
      isDebit
      isCredit
      purpose
    }
  }
`;

const useAllCreditTransferTypes = () => {
  const { loading, error, data } = useQuery(GET_ALL_CREDIT_TRANSFER_TYPES, {
    fetchPolicy: 'no-cache',
    variables: {
      query: {
        isCredit: true,
      },
    },
  });

  return {
    loading,
    error,
    data: data?.transfertypes ?? [],
  };
};

export default useAllCreditTransferTypes;
